import { types, Instance } from 'mobx-state-tree';

export const RawSheetData = types.model({
  headers: types.array(types.string),
  content: types.array(types.array(types.union(types.undefined, types.string))),
  extension: types.maybe(types.string),
});

export type IRawSheetData = Instance<typeof RawSheetData>;
